// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { headerLinkListStyles } from "@insite/content-library/Widgets/Header/HeaderLinkList";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        padding: 0;
        display: flex;
        gap: 32px;
        align-items: center;
        justify-content: flex-end;
    `,
};

headerLinkListStyles.link = {
    color: "text.main",
    typographyProps: {
        ...fontConfig.singleLineSmall,
        weight: fontConfig.weight.regular,
        css: css`
            text-transform: capitalize;
            display: inline-block;
        `,
    },
    css: css`
        & > ${IconWrapper} {
            opacity: 1;
            color: ${color("text.main")};
        }
    `,
};
